<template>
  <div class="page-item clickable" :class="[{ 'page-default': isDefault() }, { 'child-hover': childHovering }, { 'disabled': disabled }]" @click.stop="emitCheck">
    <div class="col align-self-stretch d-flex">
      <div class="row">
        <div class="page-item-info d-flex align-items-center">
          <div class="page-item-info-image">
            <img v-if="isOriginalShopifyPage || page.isGpTemplate == false || page.gp_unlink == true" :src="publicPath + require('@/core/assets/Shopify.jpg')"  />
            <img v-else-if="(page.thumbnail_url && page.thumbnail_url > '')" :src="getThumbnail(page.thumbnail_url)" @error="imageLoadOnError"/>
            <img v-else :src="publicPath + require('@/core/assets/ThumbnailPlaceholder.jpg')" />
          </div>
          <div class="page-item-info-body ml-2">
            <div class="page-item-info-body-title">
              <p class="typo-heading16 typo-medium text-ligh-high" :class="listType == 'productCollectionPages' ? 'products-collections' : ''" :title="titlePage">{{ titlePage }}</p>
            </div>
            <div class="page-item-info-time mt-half text-grey2">
              <p class="typo-paragraph12 typo-regular text-ligh-low d-flex" v-if="!isOriginalShopifyPage"><span v-html="authorText.text" :class="authorText.class"></span> {{ $t("page.sort.modified") }} {{ timeago }}</p>
              <p class="typo-paragraph12 typo-regular text-ligh-low" v-else>{{ descPage }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Group name, publish/unpublish status -->
    <div class="col-xl-3 mh80 d-flex align-items-center justify-content-center" v-if="listType != 'productCollectionPages'">
      <div class="row flex-column align-items-center">
        <template v-if="['subpages', 'articlepages'].includes(pageType)">
          <div class="page-item-status text-center" v-if="!isDefault()">
            <p class="typo-paragraph12 text-lightmode2">
              <span class="d-flex align-items-center text-success" v-if="isPublishScheduled">
                <ScheduleIcon />
                <span class="ml-half">{{ $t("page.scheduledAt", { time: publishScheduleAt }) }}</span>
              </span>
              <template v-else-if="page.published_at">{{ $t("generals.published") }} {{ publishAgo }}</template>
              <template v-else>{{ $t("generals.draft") }}</template>
            </p>
          </div>
        </template>
        <div class="page-item-group d-flex align-items-center typo-paragraph12 text-lightmode2 my-1 text-center" v-if="['subpages', 'articlepages', 'homepages'].includes(pageType) && groupName">
          <p class="page-item-group-name"><i class="icon icon-group typo-icon-12 text-light-low mr-1"></i>{{ groupName }}</p>
        </div>
        <div class="page-item-status page-item-group-name text-center my-half" v-if="['homepages', 'collectionpages', 'productpages'].includes(pageType)">
          <p class="typo-paragraph12 text-lightmode2">
            <span class="d-flex align-items-center text-success" v-if="isPublishScheduled">
              <ScheduleIcon />
              <span class="ml-half">{{ $t("page.scheduledAt", { time: publishScheduleAt }) }}</span>
            </span>
          </p>
        </div>
      </div>
    </div>

    <!-- Count items, Default status - only for Product Pages and Collection pages -->
    <div class="col-xl-2 d-flex flex-column align-self-stretch align-items-center justify-content-center" v-if="listType == 'productCollectionPages'">
      <div class="row flex-column align-items-center">
        <div class="page-item-status text-center">
          <template v-if="isDefault()">
            <svg class="mr-half" width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="4" cy="4.5" r="3.5" fill="#3C67FF" />
            </svg>
            <span class="typo-button14 typo-medium text-light-high">{{ defaultText }}</span>
          </template>
          <template v-else>
            <p v-if="loadingList" class="skeleton skeleton-light loading-count"></p>
            <p class="typo-paragraph12 typo-regular text-light-low" v-else>{{ itemCount }}</p>
          </template>
        </div>
      </div>
    </div>

    <!-- Check mark -->
    <div class="col-3 col-md-2 col-lg-1 col-mlg-2 col-xl-1 mh80 d-flex align-items-center">
      <label class="checkmark-input">
        <input type="checkbox" name="checkbox[]" :checked="isChecked" readonly disabled />
        <span class="checkmark"></span>
      </label>
    </div>

  </div>
</template>

<script>
import { TimeMaker } from "@/plugins";
import { mapState, mapGetters } from "vuex";
import ScheduleIcon from '@/core/shared/ScheduleIcon.vue';
import schedulePublish from '@/mixins/schedulePublish';
export default {
  name: "PageItem",
  components: {
    ScheduleIcon,
  },
  mixins: [schedulePublish("page")],
  props: {
    page: Object,
    type: {
      type: String,
      default: "row"
    },
    pageType: String,
    listType: String,
    templateList: [Object, Array],
    isChecked: Boolean,
    total: Number,
    loadingList: Boolean,
    img: String,
    disabled: Boolean
  },
  data() {
    return {
      textDefault: {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      },
      descDefault: {
        "Theme Product Template": this.$t("page.shopifyProductTemplate"),
        "Theme Collection Template": this.$t("page.shopifyCollectionTemplate"),
        "Theme Index Template": this.$t("page.shopifyHomeTemplate"),
        "Your first Homepage": this.$t("page.shopifyHomeTemplate"),
      },
      makeDefaultPages: ["template-collection", "template-index", "template-product"],
      originShopify: {
        image: "https://ucarecdn.com/d7cb7ae4-bd2a-4539-b838-5dbb071d5603/-/format/auto/-/preview/3000x3000/-/quality/lighter/"
      },
      childHovering: false,
    };
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    ...mapGetters("group", {
      groups: "groups"
    }),
    authorText(){
      if ( this.pageType == 'subpages') {
        if (this.page.author == null ){
          return {
            text : `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-half">
                      <path d="M12.404 3.92665C12.3963 3.85631 12.3337 3.82498 12.287 3.82498C12.2403 3.82498 11.217 3.74698 11.217 3.74698C11.217 3.74698 10.5063 3.03631 10.4203 2.96598C10.3423 2.88798 10.1937 2.91131 10.1313 2.92698C10.1237 2.92698 9.975 2.97398 9.733 3.05198C9.491 2.35665 9.077 1.72398 8.335 1.72398H8.26467C8.061 1.45831 7.79567 1.33331 7.577 1.33331C5.85867 1.33331 5.03067 3.48131 4.773 4.57498C4.10133 4.78598 3.62467 4.92631 3.57 4.94998C3.195 5.06698 3.18733 5.07498 3.14033 5.42631C3.10133 5.69198 2.125 13.245 2.125 13.245L9.725 14.6666L13.8493 13.7763C13.857 13.7606 12.412 3.99698 12.404 3.92665ZM9.311 3.16098C9.12367 3.21565 8.897 3.28598 8.67067 3.36398V3.22365C8.67067 2.80198 8.616 2.45831 8.51433 2.18465C8.90467 2.23165 9.147 2.66131 9.311 3.16098ZM8.03767 2.27065C8.13933 2.53631 8.20967 2.91131 8.20967 3.42665V3.50465C7.788 3.63731 7.34267 3.77031 6.88167 3.91865C7.13933 2.93465 7.63167 2.45031 8.03767 2.27065ZM7.53767 1.78631C7.61567 1.78631 7.694 1.81765 7.75633 1.86431C7.20167 2.12198 6.616 2.77031 6.37367 4.08265C6.00667 4.19965 5.655 4.30131 5.31933 4.41065C5.60067 3.41098 6.30367 1.78631 7.53767 1.78631Z" fill="#7CB342"/>
                      <path d="M12.2887 3.80932C12.2417 3.80932 11.2187 3.73132 11.2187 3.73132C11.2187 3.73132 10.508 3.02065 10.422 2.95032C10.3903 2.91899 10.3513 2.90332 10.3203 2.90332L9.75 14.6667L13.8743 13.7763C13.8743 13.7763 12.4293 3.99699 12.4213 3.92665C12.39 3.85632 12.3353 3.82499 12.2887 3.80932Z" fill="#558B2F"/>
                      <path d="M8.26283 6.1977L7.77117 7.6807C7.77117 7.6807 7.3255 7.44237 6.7955 7.44237C6.00417 7.44237 5.96583 7.9417 5.96583 8.0647C5.96583 8.7407 7.73283 9.00203 7.73283 10.5924C7.73283 11.8447 6.9415 12.6514 5.8735 12.6514C4.58283 12.6514 3.9375 11.8524 3.9375 11.8524L4.28317 10.7154C4.28317 10.7154 4.95917 11.2994 5.52783 11.2994C5.90417 11.2994 6.05783 11.0074 6.05783 10.7924C6.05783 9.9087 4.6135 9.87037 4.6135 8.4107C4.6135 7.18903 5.4895 6.00603 7.26417 6.00603C7.9245 5.99803 8.26283 6.1977 8.26283 6.1977Z" fill="white"/>
                    </svg>
                    ` + this.$t('empty.generals.fromShopify') + ` -&nbsp;`,
            class : "from-shopify d-flex align-item-center"
          }
        }
      }
      if ( this.pageType == 'articlepages') {
        if (this.page.author != 'Shopify API'){
          return {
            text : `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-half">
                      <path d="M12.404 3.92665C12.3963 3.85631 12.3337 3.82498 12.287 3.82498C12.2403 3.82498 11.217 3.74698 11.217 3.74698C11.217 3.74698 10.5063 3.03631 10.4203 2.96598C10.3423 2.88798 10.1937 2.91131 10.1313 2.92698C10.1237 2.92698 9.975 2.97398 9.733 3.05198C9.491 2.35665 9.077 1.72398 8.335 1.72398H8.26467C8.061 1.45831 7.79567 1.33331 7.577 1.33331C5.85867 1.33331 5.03067 3.48131 4.773 4.57498C4.10133 4.78598 3.62467 4.92631 3.57 4.94998C3.195 5.06698 3.18733 5.07498 3.14033 5.42631C3.10133 5.69198 2.125 13.245 2.125 13.245L9.725 14.6666L13.8493 13.7763C13.857 13.7606 12.412 3.99698 12.404 3.92665ZM9.311 3.16098C9.12367 3.21565 8.897 3.28598 8.67067 3.36398V3.22365C8.67067 2.80198 8.616 2.45831 8.51433 2.18465C8.90467 2.23165 9.147 2.66131 9.311 3.16098ZM8.03767 2.27065C8.13933 2.53631 8.20967 2.91131 8.20967 3.42665V3.50465C7.788 3.63731 7.34267 3.77031 6.88167 3.91865C7.13933 2.93465 7.63167 2.45031 8.03767 2.27065ZM7.53767 1.78631C7.61567 1.78631 7.694 1.81765 7.75633 1.86431C7.20167 2.12198 6.616 2.77031 6.37367 4.08265C6.00667 4.19965 5.655 4.30131 5.31933 4.41065C5.60067 3.41098 6.30367 1.78631 7.53767 1.78631Z" fill="#7CB342"/>
                      <path d="M12.2887 3.80932C12.2417 3.80932 11.2187 3.73132 11.2187 3.73132C11.2187 3.73132 10.508 3.02065 10.422 2.95032C10.3903 2.91899 10.3513 2.90332 10.3203 2.90332L9.75 14.6667L13.8743 13.7763C13.8743 13.7763 12.4293 3.99699 12.4213 3.92665C12.39 3.85632 12.3353 3.82499 12.2887 3.80932Z" fill="#558B2F"/>
                      <path d="M8.26283 6.1977L7.77117 7.6807C7.77117 7.6807 7.3255 7.44237 6.7955 7.44237C6.00417 7.44237 5.96583 7.9417 5.96583 8.0647C5.96583 8.7407 7.73283 9.00203 7.73283 10.5924C7.73283 11.8447 6.9415 12.6514 5.8735 12.6514C4.58283 12.6514 3.9375 11.8524 3.9375 11.8524L4.28317 10.7154C4.28317 10.7154 4.95917 11.2994 5.52783 11.2994C5.90417 11.2994 6.05783 11.0074 6.05783 10.7924C6.05783 9.9087 4.6135 9.87037 4.6135 8.4107C4.6135 7.18903 5.4895 6.00603 7.26417 6.00603C7.9245 5.99803 8.26283 6.1977 8.26283 6.1977Z" fill="white"/>
                    </svg>
                    ` + this.$t('empty.generals.fromShopify') + ` -&nbsp;`,
            class : "from-shopify d-flex align-item-center"
          }
        }
      }
      return {
        text:"",
        class:""
      }
    },
    timeago() {
      return new TimeMaker(this.page.updated_at).ago(this.language);
    },
    publishAgo() {
      return new TimeMaker(this.page.published_at).ago(this.language);
    },
    groupName() {
      let group = this.groups(this.pageType).find(e => e.id == this.page.page_group_id);
      if (group) {
        return group.name;
      }
      return "";
    },
    titlePage() {
      if (this.isOriginalShopifyPage) {
        return this.textDefault[this.page.title];
      }
      return this.page.title;
    },
    descPage() {
      if (this.isOriginalShopifyPage) {
        return this.descDefault[this.page.title];
      }
      return "";
    },
    currentPage() {
      let currentPageText = {
        "template-index": `| ${this.$t("page.currentHome")}`,
        "template-product": `| ${this.$t("page.currentProduct")}`,
        "template-collection": `| ${this.$t("page.currentCollection")}`
      };
      return this.isDefault() ? currentPageText[this.page.type] : "";
    },
    defaultText() {
      if (this.isBackToOriginal()) {
        return this.$t("page.backOriginal");
      } else if (this.page.published == true) {
        return this.$t("generals.default");
      } else {
        return this.$t("generals.makeDefault");
      }
    },
    isOriginalShopifyPage() {
      return this.textDefault[this.page.title] ? true : false;
    },
    isMakeDefault() {
      return this.page.published;
    },
    itemCount() {
      let number = 0;
      if (this.page.assigns != null) {
        number = this.page.assigns.length;
      }

      if (this.isMakeDefault) {
        number = this.total;
      }
      if (this.pageType == "productpages") {
        if (number > 1) {
          return number + " " + this.$tc("page.productLower", 2);
        }
        return number + " " + this.$tc("page.productLower", 1);
      }
      if (number > 1) {
        return number + " " + this.$tc("page.collectionLower", 2);
      }
      return number + " " + this.$tc("page.collectionLower", 1);
    }
  },
  methods: {
    getFileExtensionFromSource(src) {
      if(!src.includes(".")) return undefined;
      const lastItem = src.split(".").pop();
      if(!lastItem) return undefined;
      const extension = lastItem.split("?").shift();
      return extension;
    },
    isDefault() {
      if (this.layoutDefaultStatus()) {
        return this.page.published ? true : false;
      }
    },
    isBackToOriginal() {
      return this.textDefault[this.page.title] && this.page.published == false;
    },
    layoutDefaultStatus() {
      return this.makeDefaultPages.includes(this.page.type) ? true : false;
    },
    imageURL() {
      if (this.isOriginalShopifyPage) {
        return this.originShopify.image;
      }
      return this.page.avatar;
    },
    getThumbnail(url){
      let fileExtension = this.getFileExtensionFromSource(url)
      if (!fileExtension || url.includes("ThumbnailPlaceholder")){
        return this.publicPath + require('@/core/assets/ThumbnailPlaceholder.jpg')
      }
      return (url.slice(0, url.length - (fileExtension.length + 1)) + `_thumbnail.${fileExtension}`);
    },
    mouseEnter() {
      this.childHovering = true;
    },
    mouseLeave() {
      this.childHovering = false;
    },
    imageLoadOnError(){
      this.page.thumbnail_url = this.publicPath + require('@/core/assets/ThumbnailPlaceholder.jpg')
    },
    emitCheck() {
      this.$emit("check", this.page);
    }
  }
};
</script>

<style lang="scss" scoped>
.gif-container {
  overflow: hidden;
  width: 100%;
  img {
    width: calc(100% + 2px);
    transform: translate(-1px, -1px);
  }
}
.checkmark-input {
  input[type="checkbox"] {
    display: none;
  }
}
.page-item {
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
}
</style>
